// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Feature$ReactHooksTemplate = require("./feature.res.js");
var LlmModel$ReactHooksTemplate = require("./llmModel.res.js");
var LlmProvider$ReactHooksTemplate = require("./llmProvider.res.js");

function LlmFeatureRow(props) {
  var onFeatureUpdate = props.onFeatureUpdate;
  var feature = props.feature;
  var match = React.useState(function (param) {
        return false;
      });
  var setSaving = match[1];
  var saving = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setStatusMsg = match$1[1];
  var statusMsg = match$1[0];
  var match$2 = React.useState(function (param) {
        return Feature$ReactHooksTemplate.providerId(feature) === undefined;
      });
  var setEditing = match$2[1];
  var editing = match$2[0];
  var providersWithActiveModels = List.filter(function (p) {
          return List.exists(LlmModel$ReactHooksTemplate.active, LlmProvider$ReactHooksTemplate.models(p));
        })(props.providers);
  if (!providersWithActiveModels) {
    return null;
  }
  var match$3 = Feature$ReactHooksTemplate.llmProvider(feature);
  var match$4 = Feature$ReactHooksTemplate.providerId(feature);
  var selectedProvider = match$3 !== undefined ? Caml_option.some(Caml_option.valFromOption(match$3)) : (
      match$4 !== undefined ? Belt_List.getBy(providersWithActiveModels, (function (p) {
                var id = LlmProvider$ReactHooksTemplate.id(p);
                if (id !== undefined) {
                  return id === match$4;
                } else {
                  return false;
                }
              })) : undefined
    );
  var models = selectedProvider !== undefined ? List.filter(LlmModel$ReactHooksTemplate.active)(LlmProvider$ReactHooksTemplate.models(Caml_option.valFromOption(selectedProvider))) : /* [] */0;
  var match$5 = Feature$ReactHooksTemplate.llmModel(feature);
  var match$6 = Feature$ReactHooksTemplate.modelId(feature);
  var selectedModel = match$5 !== undefined ? match$5 : (
      match$6 !== undefined ? Belt_List.getBy(models, (function (m) {
                var id = LlmModel$ReactHooksTemplate.id(m);
                if (id !== undefined) {
                  return id === match$6;
                } else {
                  return false;
                }
              })) : undefined
    );
  var onProviderChange = function (e) {
    var pid = Pervasives.int_of_string_opt(e.target.value);
    if (pid === undefined) {
      return Curry._1(onFeatureUpdate, Feature$ReactHooksTemplate.setLlmModel(Feature$ReactHooksTemplate.setLlmProvider(feature, undefined), undefined));
    }
    var p = Belt_List.getBy(providersWithActiveModels, (function (p) {
            var id = LlmProvider$ReactHooksTemplate.id(p);
            if (id !== undefined) {
              return id === pid;
            } else {
              return false;
            }
          }));
    if (p !== undefined) {
      return Curry._1(onFeatureUpdate, Feature$ReactHooksTemplate.setLlmModel(Feature$ReactHooksTemplate.setLlmProvider(feature, Caml_option.some(Caml_option.valFromOption(p))), undefined));
    }
    
  };
  var onModelChange = function (e) {
    var mid = Pervasives.int_of_string_opt(e.target.value);
    if (mid === undefined) {
      return Curry._1(onFeatureUpdate, Feature$ReactHooksTemplate.setLlmModel(feature, undefined));
    }
    var m = Belt_List.getBy(models, (function (m) {
            var id = LlmModel$ReactHooksTemplate.id(m);
            if (id !== undefined) {
              return id === mid;
            } else {
              return false;
            }
          }));
    if (m !== undefined) {
      return Curry._1(onFeatureUpdate, Feature$ReactHooksTemplate.setLlmModel(feature, m));
    }
    
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: Feature$ReactHooksTemplate.name(feature),
                              className: "text-lg font-semibold text-indigo-700 capitalize tracking-wide"
                            }),
                        JsxRuntime.jsx("div", {
                              children: Feature$ReactHooksTemplate.description(feature),
                              className: "text-sm text-gray-600"
                            })
                      ],
                      className: "mb-3"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "AI Provider",
                                      className: "block text-sm font-medium text-gray-700 mb-1"
                                    }),
                                JsxRuntime.jsxs("select", {
                                      children: [
                                        JsxRuntime.jsx("option", {
                                              children: "-- Select Provider --",
                                              value: ""
                                            }),
                                        $$Array.of_list(List.map((function (p) {
                                                    var pid = LlmProvider$ReactHooksTemplate.id(p);
                                                    if (pid !== undefined) {
                                                      return JsxRuntime.jsx("option", {
                                                                  children: LlmProvider$ReactHooksTemplate.name(p),
                                                                  value: String(pid)
                                                                });
                                                    } else {
                                                      return null;
                                                    }
                                                  }), providersWithActiveModels))
                                      ],
                                      className: "w-full border rounded-lg p-2 focus:ring-2 " + (
                                        editing ? "focus:ring-indigo-500" : "bg-gray-100 text-gray-500"
                                      ),
                                      disabled: !editing,
                                      value: selectedProvider !== undefined ? String(Belt_Option.getExn(LlmProvider$ReactHooksTemplate.id(Caml_option.valFromOption(selectedProvider)))) : "",
                                      onChange: onProviderChange
                                    })
                              ],
                              className: "flex-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "AI Model",
                                      className: "block text-sm font-medium text-gray-700 mb-1"
                                    }),
                                JsxRuntime.jsxs("select", {
                                      children: [
                                        JsxRuntime.jsx("option", {
                                              children: "-- Select Model --",
                                              value: ""
                                            }),
                                        $$Array.of_list(List.map((function (m) {
                                                    var mid = LlmModel$ReactHooksTemplate.id(m);
                                                    if (mid !== undefined) {
                                                      return JsxRuntime.jsx("option", {
                                                                  children: LlmModel$ReactHooksTemplate.name(m),
                                                                  value: String(mid)
                                                                });
                                                    } else {
                                                      return null;
                                                    }
                                                  }), models))
                                      ],
                                      className: "w-full border rounded-lg p-2 focus:ring-2 " + (
                                        editing && selectedProvider !== undefined ? "focus:ring-indigo-500" : "bg-gray-100 text-gray-500"
                                      ),
                                      disabled: !editing || selectedProvider === undefined,
                                      value: selectedModel !== undefined ? String(Belt_Option.getExn(LlmModel$ReactHooksTemplate.id(selectedModel))) : "",
                                      onChange: onModelChange
                                    })
                              ],
                              className: "flex-1"
                            }),
                        editing ? JsxRuntime.jsx("button", {
                                children: saving ? "Saving..." : "Save",
                                className: "px-4 py-2 rounded-lg text-white " + (
                                  saving ? "bg-gray-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700"
                                ),
                                disabled: saving,
                                onClick: (function (param) {
                                    Curry._1(setSaving, (function (param) {
                                            return true;
                                          }));
                                    Curry._1(setStatusMsg, (function (param) {
                                            
                                          }));
                                    var match = Feature$ReactHooksTemplate.id(feature);
                                    if (match !== undefined && selectedProvider !== undefined) {
                                      var providerId = Belt_Option.getExn(LlmProvider$ReactHooksTemplate.id(Caml_option.valFromOption(selectedProvider)));
                                      var modelId = Belt_Option.getWithDefault(Belt_Option.flatMap(selectedModel, LlmModel$ReactHooksTemplate.id), 0);
                                      var params = {};
                                      params["feature_id"] = match;
                                      params["llm_provider_id"] = providerId;
                                      params["llm_model_id"] = modelId;
                                      var integrationId = Feature$ReactHooksTemplate.integrationId(feature);
                                      var match$1 = integrationId !== undefined ? [
                                          "/api/v1/app_features/" + String(integrationId) + "/update",
                                          Http$ReactHooksTemplate.fetchPostJSON
                                        ] : [
                                          "/api/v1/app_features",
                                          Http$ReactHooksTemplate.fetchPostJSON
                                        ];
                                      Js_promise.$$catch((function (param) {
                                              Curry._1(setStatusMsg, (function (param) {
                                                      return [
                                                              "Network error",
                                                              false
                                                            ];
                                                    }));
                                              Curry._1(setSaving, (function (param) {
                                                      return false;
                                                    }));
                                              return Promise.resolve();
                                            }), Js_promise.then_((function (res) {
                                                  var status = Json_decode.field("status", (function (param) {
                                                          return Json_decode.withDefault("failed", Json_decode.string, param);
                                                        }), res);
                                                  if (status === "success") {
                                                    Curry._1(setStatusMsg, (function (param) {
                                                            return [
                                                                    "Integration saved successfully!",
                                                                    true
                                                                  ];
                                                          }));
                                                    Curry._1(setEditing, (function (param) {
                                                            return false;
                                                          }));
                                                  } else {
                                                    var errors = Json_decode.optional((function (param) {
                                                            return Json_decode.field("errors", (function (param) {
                                                                          return Json_decode.list(Json_decode.string, param);
                                                                        }), param);
                                                          }), res);
                                                    var msg = errors !== undefined && errors !== /* [] */0 ? "Error: " + Js_array.joinWith(",", Belt_List.toArray(errors)) : "Failed to save";
                                                    Curry._1(setStatusMsg, (function (param) {
                                                            return [
                                                                    msg,
                                                                    false
                                                                  ];
                                                          }));
                                                  }
                                                  Curry._1(setSaving, (function (param) {
                                                          return false;
                                                        }));
                                                  return Promise.resolve();
                                                }), Curry._2(match$1[1], match$1[0], params)));
                                      return ;
                                    }
                                    Curry._1(setStatusMsg, (function (param) {
                                            return [
                                                    "Please select a provider first",
                                                    false
                                                  ];
                                          }));
                                    Curry._1(setSaving, (function (param) {
                                            return false;
                                          }));
                                  })
                              }) : JsxRuntime.jsx("button", {
                                children: "Edit",
                                className: "px-4 py-2 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-white",
                                onClick: (function (param) {
                                    Curry._1(setEditing, (function (param) {
                                            return true;
                                          }));
                                  })
                              })
                      ],
                      className: "flex gap-6 items-end"
                    }),
                editing && Feature$ReactHooksTemplate.providerId(feature) !== undefined ? JsxRuntime.jsx("button", {
                        children: "Cancel",
                        className: "mt-2 text-sm text-gray-600 underline",
                        onClick: (function (param) {
                            Curry._1(setEditing, (function (param) {
                                    return false;
                                  }));
                          })
                      }) : null,
                statusMsg !== undefined ? JsxRuntime.jsx("div", {
                        children: statusMsg[0],
                        className: "mt-3 text-sm font-medium " + (
                          statusMsg[1] ? "text-green-600" : "text-red-600"
                        )
                      }) : null
              ],
              className: "border border-gray-200 rounded-lg p-4 hover:shadow transition-shadow bg-white"
            });
}

var make = LlmFeatureRow;

exports.make = make;
/* react Not a pure module */
